export const pathSafeString = str => {
  return str.replace(/\W+/g, '-').toLowerCase();
};


export const styleSafeString = (str) => {
  str = str.replace(/[!\"#$%&'\(\)\*\+,\.\/:;<=>\?\@\[\\\]\^`\{\|\}~]/g, '')
  str = str.replace(/\s+/g, '-').toLowerCase();
  return str;
}